import i18n from "i18next"
import { initReactI18next } from "react-i18next"
i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    // debug if environment is not production
    debug: process.env.NODE_ENV !== "production",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: (value, format, lng) => {
        if (format === "ordinal") {
          const n = Number(value)
          const lang = lng ? lng.toLowerCase() : "en"

          // Español (1.er / 1ro, 2.º / 2do...)
          if (lang.startsWith("es")) {
            const esSuffixes = { 1: "1.er", 2: "2.º", 3: "3.er" } // o '1ro', '2do', '3ro'
            return esSuffixes[n] || `${n}.º`
          }

          // Francés (1er, 2e, 3e...)
          if (lang.startsWith("fr")) {
            return n === 1 ? "1er" : `${n}e`
          }

          // Inglés (1st, 2nd, 3rd, 4th...)
          const pr = new Intl.PluralRules("en", { type: "ordinal" })
          const enSuffixes = { one: "st", two: "nd", few: "rd", other: "th" }
          return `${n}${enSuffixes[pr.select(n)] || "th"}`
        }

        return value
      },
    },
    defaultNS: "translations",
    resources: {},
  })
// }

export default i18n
